import { stripUuid } from "./complianceExport";
import "./CompliancePipeline.css";

const defaultOptionLabel = (d) => stripUuid(d.name);

/**
 * Labelled document <select> shared by every compliance view (discovery,
 * Zulassung template, quick sheet, product sheets), so they all use the same
 * design-system field instead of each rendering a bare native select.
 */
export default function DocumentPicker({
  id,
  label,
  placeholder,
  documents,
  value,
  onChange,
  optionLabel = defaultOptionLabel,
}) {
  return (
    <div className="ds-field cp-doc-field">
      <label htmlFor={id} className="ds-label">{label}</label>
      <select id={id} className="ds-select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{placeholder}</option>
        {documents.map((d) => (
          <option key={d.document_id} value={d.document_id}>{optionLabel(d)}</option>
        ))}
      </select>
    </div>
  );
}
